export default function initHeaderFunctions() {
    const $container = $('[locale-dropdown-container]');
    const $sidecontainer = $('[sidenav-dropdown-container]');
    const $mainMenu = $('[side-menu]');
    const $header = $('header');

    $('[locale-dropdown]')
        .on('click', () => {
            if ($container.hasClass('d-none')) {
                $container.removeClass('d-none');
            } else {
                $container.addClass('d-none');
            }
        });

    $('[side-menu-toggle]')
        .on('click', () => {
            $header.removeClass('drop-shadow');
            if ($mainMenu.hasClass('d-none')) {
                $mainMenu.removeClass('d-none');
                $mainMenu.removeAttr('aria-hidden');
                $mainMenu.addClass('d-flex');
            } else {
                $mainMenu.removeClass('d-flex');
                $mainMenu.addClass('d-none');
                $header.addClass('drop-shadow');
            }
        });

    $('[sidenav-dropdown]')
        .on('click', (e) => {
            if ($sidecontainer.hasClass('d-none')) {
                $sidecontainer.removeClass('d-none');
                e.preventDefault();
            }
        });


    const $mainHeader = $('[main-header]');
    const $afterScrollHeader = $('[second-header]');
    const $heroImage = $('section.hero img');
    const $heroIframe = $('section.hero iframe');

    const checkHeaderScroll = () => {
        let heroBottom = $('.hero')[0].getBoundingClientRect().bottom;
        if ($(window)
            .scrollTop() <= heroBottom) {
            $header.removeClass('drop-shadow');
            $header.removeClass('position-fixed')
                .removeClass('bg-white')
                .addClass('position-absolute');
            $afterScrollHeader.attr('aria-hidden', 'true');
            $mainHeader.removeAttr('aria-hidden');
        }
        if ($(window)
            .scrollTop() > heroBottom || ($heroImage.length < 1 && $heroIframe.length < 1)) {
            $header.removeClass('position-absolute')
                .addClass('position-fixed bg-white');
            $mainHeader.attr('aria-hidden', 'true');
            $afterScrollHeader.removeClass('d-none');
            $afterScrollHeader.removeAttr('aria-hidden');
            if ($mainMenu.hasClass('d-none')) {
                $header.addClass('drop-shadow');
            }
        }
    };
    checkHeaderScroll();
    document.addEventListener('scroll', () => {
        checkHeaderScroll();
    });
    document.addEventListener('resize', () => {
        checkHeaderScroll();
    });
    document.addEventListener('ready', () => {
        checkHeaderScroll();
    });
}
